import moment from 'moment';
import { interval, Observable } from 'rxjs';
import { concatMap, takeUntil } from 'rxjs/operators';
import { BatteryState } from '../service/hw-service-model';
import { SystemService } from '../service/system.service';

export class AutoAction {
  private endMoment: moment.Moment | null = null;
  private pauseMoment: moment.Moment | null = null;

  constructor(private textCallback: (v: string) => void, private endCallback: () => void) {}

  start(minutes: number, dead: Observable<void>) {
    this.endMoment = moment().add(minutes, 'minutes');
    interval(1000)
      .pipe(takeUntil(dead))
      .subscribe(() => {
        if (this.pauseMoment !== null) {
          return;
        }
        const diff = moment.duration(this.endMoment!.diff(moment()));
        const text = diff.minutes().toString().padStart(2, '0') + ':' + diff.seconds().toString().padStart(2, '0');
        this.textCallback(text);
        if (diff.asMilliseconds() < 0) {
          this.endCallback();
        }
      });
  }

  restart(minutes: number) {
    this.endMoment = moment().add(minutes, 'minutes');
  }

  pause() {
    this.pauseMoment = moment();
  }

  continue() {
    this.endMoment!.add(moment().diff(this.pauseMoment));
    this.pauseMoment = null;
  }

  isPaused() {
    return this.pauseMoment !== null;
  }
}

export class BatteryAutoActionHelper {
  constructor(private action: AutoAction, private systemService: SystemService, private dead: Observable<void>) {}

  run() {
    this.systemService
      .connect()
      .pipe(
        concatMap(() => this.systemService.getBatteryReport()),
        takeUntil(this.dead),
      )
      .subscribe((r0) => {
        this.action.start(Math.floor(Math.max(r0.capacity, 0) / 10) * 3, this.dead);
        this.action.pause();
        interval(1000)
          .pipe(takeUntil(this.dead))
          .subscribe(() => {
            this.systemService
              .getBatteryReport()
              .pipe(takeUntil(this.dead))
              .subscribe((r) => {
                if (r.state === BatteryState.Discharging) {
                  if (this.action.isPaused()) {
                    this.action.continue();
                  }
                } else {
                  if (!this.action.isPaused()) {
                    this.action.pause();
                  }
                }
              });
          });
      });
  }
}
